// extracted by mini-css-extract-plugin
export var centered = "MarkdownContent-module--centered--8e953";
export var markdownContainer = "MarkdownContent-module--markdownContainer--6a3c2";